import { atom, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * 알람정보
 */
// atom
const alarmInfo = atom({
  key: 'alarmInfo',
  default: []
});

// hook
function useAlarm() {
  const [alarm, setAlarm] = useRecoilState(alarmInfo);
  const resetAlarm = useResetRecoilState(alarmInfo);

  return {
    alarm,
    setAlarm,
    resetAlarm
  };
}

export default useAlarm;
